import { createReducer } from 'reduxsauce'
import Immutable from 'seamless-immutable'
import { BusinessTypes } from "../actions/business-actions";

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
    fetchingOne: null,
    fetchingAll: null,
    fetchingBusinessSummary: false,
    fetchingQrCode: false,
    fetchingIndustries: false,
    creating: null,
    updating: null,
    deleting: null,
    closingNotification: false,
    updatingPspBill: false,
    togglingReqsEnabled: false,
    togglingAllowDuplicatePhone: false,
    creatingSignupReqs: false,
    fetchingSignupReqs: false,
    deletingSignupReq: false,
    fetchingSignupReqExclusions: false,
    creatingSignupReqExclusions: false,
    deletingSignupReqExclusion: false,

    closedNotication: null,
    business: null,
    businesses: null,
    qrCode: null,
    industries: null,
    businessSummary: null,
    updatedPspBill: null,
    signupReqs: null,
    signupReqExclusions: null,

    errorOne: null,
    errorAll: null,
    errorCreating: null,
    errorUpdating: null,
    errorDeleting: null,
    errorClosingNotification: null,
    errorBusinessSummary: null,
    errorQrCode: null,
    errorIndustries: null,
    errorUpdatingPspBill: null,
    errorTogglingReqsEnabled: null,
    errorTogglingAllowDuplicatePhone: null,
    errorCreateSignupReqs: null,
    errorFetchSignupReqs: null,
    errorDeleteSignupReq: null,
    errorFetchSignupReqExclusions: null,
    errorCreateSignupReqExclusions: null,
    errorDeleteSignupReqExclusion: null
})

/* ------------- Reducers ------------- */

// request the data from an api
export const request = (state) => { return { ...state, fetchingOne: true, business: null } }
// request the data from an api
export const allRequest = (state) => { return { ...state, fetchingAll: true, business: null } }
// request data from an api
export const businessSummaryRequest = (state) => {
    return { ...state, fetchingBusinessSummary: true, businessSummary: null }
}
// request to update from an api
export const createRequest = (state) => { return { ...state, creating: true } }
// request to update from an api
export const updateRequest = (state) => { return { ...state, updating: true } }

export const updatePspBillRequest = (state) => { return { ...state, updatingPspBill: true } }

export const toggleReqsEnabledRequest = (state) => {
    return { ...state, togglingReqsEnabled: true, errorTogglingReqsEnabled: null }
}

export const toggleAllowDuplicatePhoneRequest = (state) => {
    return { ...state, togglingAllowDuplicatePhone: true, errorTogglingAllowDuplicatePhone: null }
}

export const createSignupReqsRequest = (state) => {
    return { ...state, creatingSignupReqs: true, errorCreateSignupReqs: null }
}

export const fetchSignupReqsRequest = (state) => {
    return { ...state, fetchingSignupReqs: true, errorFetchSignupReqs: null }
}

export const deleteSignupReqRequest = (state) => {
    return { ...state, deletingSignupReq: true, errorDeleteSignupReq: null }
}

export const fetchSignupReqExclusionsRequest = (state) => {
    return { ...state, fetchingSignupReqExclusions: true, errorFetchSignupReqExclusions: null }
}

export const createSignupReqExclusionsRequest = (state) => {
    return { ...state, creatingSignupReqExclusions: true, errorCreateSignupReqExclusions: null }
}

export const deleteSignupReqExclusionRequest = (state) => {
    return { ...state, deletingSignupReqExclusion: true, errorDeleteSignupReqExclusion: null }
}

// request to delete from an api
export const deleteRequest = (state) => { return { ...state, deleting: true } }

// request to closeNotification from an api
export const closeNotificationRequest = (state) => { return { ...state, closingNotification: true } }

// request the data from an api
export const qrCodeRequest = (state) => { return { ...state, fetchingQrCode: true, qrCode: null } }

// request the data from an api
export const industriesRequest = (state) => {
    return { ...state, fetchingIndustries: true, industries: null }
}

// successful api lookup for single entity
export const success = (state, action) => {
    const { business } = action
    return { ...state, fetchingOne: false, errorOne: null, business }
}
// successful api lookup for all entities
export const allSuccess = (state, action) => {
    const { businesses } = action
    return { ...state, fetchingAll: false, errorAll: null, businesses }
}
// successful api lookup for a business summary
export const businessSummarySuccess = (state, action) => {
    const { businessSummary } = action
    return { ...state, fetchingBusinessSummary: false, errorBusinessSummary: null, businessSummary }
}
// successful api create
export const createSuccess = (state, action) => {
    const { business } = action
    return { ...state, creating: false, errorCreating: null, business }
}
// successful api update
export const updateSuccess = (state, action) => {
    const { business } = action
    return { ...state, updating: false, errorUpdating: null, business }
}

export const updatePspBillSuccess = (state, action) => {
    const { business } = action
    return { ...state, updatingPspBill: false, errorUpdatingPspBill: null, updatedPspBill: business }
}

export const toggleReqsEnabledSuccess = (state, action) => {
    const { business } = action
    return { ...state, togglingReqsEnabled: false, errorTogglingReqsEnabled: null, business }
}

export const toggleAllowDuplicatePhoneSuccess = (state, action) => {
    const { business } = action
    return { ...state, togglingAllowDuplicatePhone: false, errorTogglingAllowDuplicatePhone: null, business }
}

export const createSignupReqsSuccess = (state, action) => {
    const { signupReqs } = action
    return { ...state, creatingSignupReqs: false, errorCreateSignupReqs: null, signupReqs }
}

export const fetchSignupReqsSuccess = (state, action) => {
    const { signupReqs } = action
    return { ...state, fetchingSignupReqs: false, errorFetchSignupReqs: null, signupReqs }
}

export const deleteSignupReqSuccess = (state, action) => {
    const { signupReqs } = action
    return { ...state, deletingSignupReq: false, errorDeleteSignupReq: null, signupReqs }
}

export const fetchSignupReqExclusionsSuccess = (state, action) => {
    const { signupReqExclusions } = action
    return { ...state, fetchingSignupReqExclusions: false, errorFetchSignupReqExclusions: null, signupReqExclusions }
}

export const createSignupReqExclusionsSuccess = (state, action) => {
    const { signupReqExclusions } = action
    return { ...state, creatingSignupReqExclusions: false, errorCreateSignupReqExclusions: null, signupReqExclusions }
}

export const deleteSignupReqExclusionSuccess = (state, action) => {
    const { signupReqExclusions } = action
    return { ...state, deletingSignupReqExclusion: false, errorDeleteSignupReqExclusion: null, signupReqExclusions }
}

// successful api delete
export const deleteSuccess = (state) => {
    return { ...state, deleting: false, errorDeleting: null, business: null }
}

// successfully closeNotification
export const closeNotificationSuccess = (state, action) => {
    const incoming = action.business
    const current = state.business
    const acknowledgedAt = incoming?.verifAcknowledgedOn || current?.verifAcknowledgedOn || new Date().toISOString()
    const base = incoming?.id ? incoming : current
    const business = base ? { ...base, verifAcknowledgedOn: acknowledgedAt } : current
    return { ...state, closingNotification: false, errorClosingNotification: null, business }
}

// successful api lookup for qrCode
export const qrCodeSuccess = (state, action) => {
    const { qrCode } = action
    return { ...state, fetchingQrCode: false, errorQrCode: null, qrCode }
}

// successful api lookup for industries
export const industriesSuccess = (state, action) => {
    const { industries } = action
    return { ...state, fetchingIndustries: false, errorIndustries: null, industries }
}

// Something went wrong fetching a single entity.
export const failure = (state, action) => {
    const { error } = action
    return { ...state, fetchingOne: false, errorOne: error, business: null }
}
// Something went wrong fetching all entities.
export const allFailure = (state, action) => {
    const { error } = action
    return { ...state, fetchingAll: false, errorAll: error, businesses: null }
}
// Something went wrong fetching business summary
export const businessSummaryFailure = (state, action) => {
    const { error } = action
    return { ...state, fetchingBusinessSummary: false, errorBusinessSummary: error, businessSummary: null }
}
// Something went wrong creating.
export const createFailure = (state, action) => {
    const { error } = action
    return { ...state, creating: false, errorCreating: error }
}
// Something went wrong updating.
export const updateFailure = (state, action) => {
    const { error } = action
    return { ...state, updating: false, errorUpdating: error }
}

export const updatePspBillFailure = (state, action) => {
    const { error } = action
    return { ...state, updatingPspBill: false, errorUpdatingPspBill: error }
}

export const toggleReqsEnabledFailure = (state, action) => {
    const { error } = action
    return { ...state, togglingReqsEnabled: false, errorTogglingReqsEnabled: error }
}

export const toggleAllowDuplicatePhoneFailure = (state, action) => {
    const { error } = action
    return { ...state, togglingAllowDuplicatePhone: false, errorTogglingAllowDuplicatePhone: error }
}

export const createSignupReqsFailure = (state, action) => {
    const { error } = action
    return { ...state, creatingSignupReqs: false, errorCreateSignupReqs: error }
}

export const fetchSignupReqsFailure = (state, action) => {
    const { error } = action
    return { ...state, fetchingSignupReqs: false, errorFetchSignupReqs: error }
}

export const deleteSignupReqFailure = (state, action) => {
    const { error } = action
    return { ...state, deletingSignupReq: false, errorDeleteSignupReq: error }
}

export const fetchSignupReqExclusionsFailure = (state, action) => {
    const { error } = action
    return { ...state, fetchingSignupReqExclusions: false, errorFetchSignupReqExclusions: error }
}

export const createSignupReqExclusionsFailure = (state, action) => {
    const { error } = action
    return { ...state, creatingSignupReqExclusions: false, errorCreateSignupReqExclusions: error }
}

export const deleteSignupReqExclusionFailure = (state, action) => {
    const { error } = action
    return { ...state, deletingSignupReqExclusion: false, errorDeleteSignupReqExclusion: error }
}
// Something went wrong deleting.
export const deleteFailure = (state, action) => {
    const { error } = action
    return { ...state, deleting: false, errorDeleting: error }
}
// Something went wrong deleting.
export const closedNoticationFailure = (state, action) => {
    const { error } = action
    return { ...state, closingNotification: false, errorClosingNotification: error }
}

//something went wrong fetching qrCode
export const qrCodeFailure = (state, action) => {
    const { error } = action
    return { ...state, fetchingQrCode: false, errorQrCode: error, qrCode: null }
}

//something went wrong fetching industries?
export const industriesFailure = (state, action) => {
    const { error } = action
    return { ...state, fetchingIndustries: false, errorIndustries: error, industries: null }
}

/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
    [BusinessTypes.BUSINESS_REQUEST]: request,
    [BusinessTypes.BUSINESS_ALL_REQUEST]: allRequest,
    [BusinessTypes.BUSINESS_SUMMARY_REQUEST]: businessSummaryRequest,
    [BusinessTypes.BUSINESS_CREATE_REQUEST]: createRequest,
    [BusinessTypes.BUSINESS_UPDATE_REQUEST]: updateRequest,
    [BusinessTypes.BUSINESS_DELETE_REQUEST]: deleteRequest,
    [BusinessTypes.BUSINESS_CLOSE_NOTIFICATION_REQUEST]: closeNotificationRequest,
    [BusinessTypes.BUSINESS_QR_CODE_REQUEST]: qrCodeRequest,
    [BusinessTypes.BUSINESS_INDUSTRIES_REQUEST]: industriesRequest,
    [BusinessTypes.UPDATE_PSP_BILL_REQUEST]: updatePspBillRequest,
    [BusinessTypes.TOGGLE_REQS_ENABLED_REQUEST]: toggleReqsEnabledRequest,
    [BusinessTypes.TOGGLE_ALLOW_DUPLICATE_PHONE_REQUEST]: toggleAllowDuplicatePhoneRequest,
    [BusinessTypes.CREATE_SIGNUP_REQS_REQUEST]: createSignupReqsRequest,
    [BusinessTypes.FETCH_SIGNUP_REQS_REQUEST]: fetchSignupReqsRequest,
    [BusinessTypes.DELETE_SIGNUP_REQ_REQUEST]: deleteSignupReqRequest,
    [BusinessTypes.FETCH_SIGNUP_REQ_EXCLUSIONS_REQUEST]: fetchSignupReqExclusionsRequest,
    [BusinessTypes.CREATE_SIGNUP_REQ_EXCLUSIONS_REQUEST]: createSignupReqExclusionsRequest,
    [BusinessTypes.DELETE_SIGNUP_REQ_EXCLUSION_REQUEST]: deleteSignupReqExclusionRequest,

    [BusinessTypes.BUSINESS_SUCCESS]: success,
    [BusinessTypes.BUSINESS_ALL_SUCCESS]: allSuccess,
    [BusinessTypes.BUSINESS_SUMMARY_SUCCESS]: businessSummarySuccess,
    [BusinessTypes.BUSINESS_CREATE_SUCCESS]: createSuccess,
    [BusinessTypes.BUSINESS_UPDATE_SUCCESS]: updateSuccess,
    [BusinessTypes.BUSINESS_DELETE_SUCCESS]: deleteSuccess,
    [BusinessTypes.BUSINESS_CLOSE_NOTIFICATION_SUCCESS]: closeNotificationSuccess,
    [BusinessTypes.BUSINESS_QR_CODE_SUCCESS]: qrCodeSuccess,
    [BusinessTypes.BUSINESS_INDUSTRIES_SUCCESS]: industriesSuccess,
    [BusinessTypes.UPDATE_PSP_BILL_SUCCESS]: updatePspBillSuccess,
    [BusinessTypes.TOGGLE_REQS_ENABLED_SUCCESS]: toggleReqsEnabledSuccess,
    [BusinessTypes.TOGGLE_ALLOW_DUPLICATE_PHONE_SUCCESS]: toggleAllowDuplicatePhoneSuccess,
    [BusinessTypes.CREATE_SIGNUP_REQS_SUCCESS]: createSignupReqsSuccess,
    [BusinessTypes.FETCH_SIGNUP_REQS_SUCCESS]: fetchSignupReqsSuccess,
    [BusinessTypes.DELETE_SIGNUP_REQ_SUCCESS]: deleteSignupReqSuccess,
    [BusinessTypes.FETCH_SIGNUP_REQ_EXCLUSIONS_SUCCESS]: fetchSignupReqExclusionsSuccess,
    [BusinessTypes.CREATE_SIGNUP_REQ_EXCLUSIONS_SUCCESS]: createSignupReqExclusionsSuccess,
    [BusinessTypes.DELETE_SIGNUP_REQ_EXCLUSION_SUCCESS]: deleteSignupReqExclusionSuccess,

    [BusinessTypes.BUSINESS_FAILURE]: failure,
    [BusinessTypes.BUSINESS_ALL_FAILURE]: allFailure,
    [BusinessTypes.BUSINESS_SUMMARY_FAILURE]: businessSummaryFailure,
    [BusinessTypes.BUSINESS_CREATE_FAILURE]: createFailure,
    [BusinessTypes.BUSINESS_UPDATE_FAILURE]: updateFailure,
    [BusinessTypes.BUSINESS_DELETE_FAILURE]: deleteFailure,
    [BusinessTypes.BUSINESS_CLOSE_NOTIFICATION_FAILURE]: closedNoticationFailure,
    [BusinessTypes.BUSINESS_QR_CODE_FAILURE]: qrCodeFailure,
    [BusinessTypes.BUSINESS_INDUSTRIES_FAILURE]: industriesFailure,
    [BusinessTypes.UPDATE_PSP_BILL_FAILURE]: updatePspBillFailure,
    [BusinessTypes.TOGGLE_REQS_ENABLED_FAILURE]: toggleReqsEnabledFailure,
    [BusinessTypes.TOGGLE_ALLOW_DUPLICATE_PHONE_FAILURE]: toggleAllowDuplicatePhoneFailure,
    [BusinessTypes.CREATE_SIGNUP_REQS_FAILURE]: createSignupReqsFailure,
    [BusinessTypes.FETCH_SIGNUP_REQS_FAILURE]: fetchSignupReqsFailure,
    [BusinessTypes.DELETE_SIGNUP_REQ_FAILURE]: deleteSignupReqFailure,
    [BusinessTypes.FETCH_SIGNUP_REQ_EXCLUSIONS_FAILURE]: fetchSignupReqExclusionsFailure,
    [BusinessTypes.CREATE_SIGNUP_REQ_EXCLUSIONS_FAILURE]: createSignupReqExclusionsFailure,
    [BusinessTypes.DELETE_SIGNUP_REQ_EXCLUSION_FAILURE]: deleteSignupReqExclusionFailure,
})
